// app.config.ts
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';
import { CandidateProvider } from './features/jobs/candidate-card/candidate-card.component';
import { JobProvider } from './features/jobs/job-card/job-card.component';
import { ssrDataInterceptor } from './interceptors/ssr-data.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    JobProvider,
    CandidateProvider,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes, 
      withComponentInputBinding(),
      withRouterConfig({onSameUrlNavigation : "reload"}), 
    ),
    provideHttpClient(
      withFetch(),
      withInterceptors([ssrDataInterceptor])
    ),
    provideClientHydration(
      withNoHttpTransferCache()
    ),
    provideAnimations(),
    provideAnimationsAsync(),
  ]
};